// extracted by mini-css-extract-plugin
export var bg_overlay = "styles-module--bg_overlay--f3f22";
export var hero_content = "styles-module--hero_content--27b62";
export var hero_content_inner = "styles-module--hero_content_inner--a7548";
export var hero_video_container = "styles-module--hero_video_container--c271e";
export var video_controls = "styles-module--video_controls--d6901";
export var video_controls_button = "styles-module--video_controls_button--617ee";
export var video_wrapper = "styles-module--video_wrapper--35dbd";